"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GanntScrollView = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var GanntMonth_1 = require("./GanntMonth");
var ScrollTileView_1 = require("../ScrollTileView");
var luxon_1 = require("luxon");
var Window_1 = require("../Window");
exports.GanntScrollView = react_1.default.forwardRef(function (_a, forwardRef) {
    var anchorDate = _a.anchorDate, _b = _a.dayCellSize, dayCellSize = _b === void 0 ? 20 : _b, renderHeader = _a.renderHeader;
    var windowSize = (0, react_1.useContext)(Window_1.SizeContext).size;
    var _c = (0, react_1.useState)(anchorDate), startDate = _c[0], setStartDate = _c[1];
    (0, react_1.useEffect)(function () {
        if (startDate !== anchorDate)
            setStartDate(anchorDate);
    }, [setStartDate, startDate, anchorDate]);
    var effectiveDate = startDate
        ? luxon_1.DateTime.fromISO(startDate, { zone: "utc" })
        : luxon_1.DateTime.utc();
    var sizeOfCellAtIndex = function (index) {
        var start = luxon_1.DateTime.fromISO(startDate !== null && startDate !== void 0 ? startDate : "", { zone: "utc" })
            .plus({ months: index })
            .startOf("month")
            .startOf("day");
        var end = start.endOf("month").startOf("day");
        var days = end.diff(start, "days").days + 1;
        var size = days * dayCellSize;
        return size;
    };
    var positionOfCellAtIndex = function (index, origin) {
        var start = luxon_1.DateTime.fromISO(startDate !== null && startDate !== void 0 ? startDate : "", { zone: "utc" })
            .startOf("month")
            .startOf("day");
        var end = start.plus({ months: index }).startOf("month").startOf("day");
        var days = end.diff(start, "days").days;
        var position = days * dayCellSize + origin;
        return position;
    };
    var indexAtDistance = function (distance) {
        var days = -Math.ceil(distance / dayCellSize);
        var start = luxon_1.DateTime.fromISO(startDate !== null && startDate !== void 0 ? startDate : "", { zone: "utc" }).startOf("month");
        var end = luxon_1.DateTime.fromISO(start.toISO(), { zone: "utc" })
            .plus({ days: days })
            .startOf("month");
        var index = end.diff(start, "months").months;
        return index;
    };
    return ((0, jsx_runtime_1.jsx)(ScrollTileView_1.ScrollTileView, __assign({ scrollDirection: "horizontal", defaultPosition: "start", anchorValue: startDate, cellSize: { width: 400, height: 200 }, sizeOfCellAtIndex: sizeOfCellAtIndex, positionOfCellAtIndex: positionOfCellAtIndex, indexAtDistance: indexAtDistance, ref: forwardRef, throttle: 500, preRenderCount: 4 }, { children: function (_a) {
            var index = _a.index, tileSize = _a.tileSize;
            var weekStart = effectiveDate
                .plus({ months: index })
                .toUTC()
                .startOf("month");
            var date = weekStart.toISO();
            return ((0, jsx_runtime_1.jsx)(GanntMonth_1.GanntMonth, { startDate: date, width: tileSize, height: windowSize.height, index: index, renderHeader: renderHeader }, void 0));
        } }), void 0));
});
